var map = {
	"./1.png": 40904,
	"./2.png": 56821,
	"./3.png": 44849,
	"./4.png": 75099,
	"./5.png": 23328,
	"./6.png": 50890,
	"./7.png": 32492,
	"./dragons_family.png": 48654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5448;